

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientAllergyParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PeriodOptions {
  value: string;
} 

export interface PatientAllergy {
   
  regId: string;
  allergyId: string;
  tenantId: string;
  branchId: string;
  duration: number;
  period: string;
  notes: string;

  //New
  isActive:string;
  severity:string;
  verificationStatus:string


  parameters?: PatientAllergyParameter[];
  links?: any;
  //Log
  createdDate?:Date;
  updatedDate?:Date;
  createdBy?:number;
  updatedBy?:number;
  createdIP?:string;
  updatedIP?:string;
}

export abstract class PatientAllergyData {
  abstract list(url: string): Observable<PatientAllergy[]>;
  abstract create(url: string, data: PatientAllergy): Observable<any>;
  abstract update(url: string, data: PatientAllergy): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
